import React from "react";

import ColorPicker from "../../../../../../components/ui/color-picker/ColorPicker";
import { ButtonGroup, TextInput as Text } from "@caelor/ui";
import IconPicker from "../../../../../../components/ui/icon-picker/IconPicker";
import Icon from "../../../../../../components/ui/icon/Icon";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  OptionMessageContainer,
  OptionMessageParagraph,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { usePanelAdvancedStore } from "../../../../../../stores/use-panel-advanced-store";
import { ALIGNMENT_OPTIONS, BOOLEAN_OPTIONS, CORNERS_OPTIONS } from "./options";
import { PANEL_ADVANCED_PROP } from "./defaults";

const PanelAdvancedSettings = () => {
  const { t } = useTranslation();

  const { data, setData } = usePanelAdvancedStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("alignment")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("align")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={ALIGNMENT_OPTIONS}
              value={data[PANEL_ADVANCED_PROP.ALIGNMENT]}
              onClick={(value) =>
                setData({ [PANEL_ADVANCED_PROP.ALIGNMENT]: value })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>
          {t("flexible-display-items")}
        </SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("icon")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data[PANEL_ADVANCED_PROP.HAS_ICON]}
              onClick={(isOn) =>
                setData({ [PANEL_ADVANCED_PROP.HAS_ICON]: isOn })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("icon")}</OptionLabel>
          <OptionContent>
            <IconPicker
              defaultTab={
                typeof data[PANEL_ADVANCED_PROP.ICON] === "object"
                  ? "Emojis"
                  : "Icons"
              }
              tabs={["Icons", "Emojis"]}
              icon={data[PANEL_ADVANCED_PROP.ICON]}
              onChange={({ value }) =>
                setData({ [PANEL_ADVANCED_PROP.ICON]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel>{t("title")}</OptionLabel>
          <OptionContent>
            <Text
              placeholder={t("add")}
              value={data[PANEL_ADVANCED_PROP.TITLE]}
              onChange={(value) =>
                setData({ [PANEL_ADVANCED_PROP.TITLE]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionMessageContainer>
          <Icon icon="atlaskit/EditorPanelIcon" size="18px" />
          <OptionMessageParagraph>
            {t("advanced-macro-content-placeholder")}
          </OptionMessageParagraph>
        </OptionMessageContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel alignToTop>{t("colors")}</OptionLabel>
          <OptionContent>
            <ColorPicker
              value={data[PANEL_ADVANCED_PROP.COLORS]}
              onChange={(value) =>
                setData({ [PANEL_ADVANCED_PROP.COLORS]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel>{t("corners")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={CORNERS_OPTIONS}
              value={data[PANEL_ADVANCED_PROP.BORDER_RADIUS]}
              options={{ input: true }}
              onClick={(value) =>
                setData({ [PANEL_ADVANCED_PROP.BORDER_RADIUS]: value })
              }
              onChange={({ target: { value } }) => {
                if (value.length < 4) {
                  setData({ [PANEL_ADVANCED_PROP.BORDER_RADIUS]: value });
                }
              }}
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
};

export default PanelAdvancedSettings;
